/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import CalendarLocale from '../calendar/ku_IQ';
import TimePickerLocale from '../time-picker/ku_IQ';

// Merge into a locale object
const locale = {
  lang: {
    placeholder: 'DÃ®rok hilbijÃªre',
    rangePlaceholder: ['DÃ®roka destpÃªkÃª', 'DÃ®roka dawÃ®n'],
    ...CalendarLocale
  },
  timePickerLocale: {
    ...TimePickerLocale
  }
};

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
export default locale;
